// Mapowania dla produktów
export const locationMap = {
  'PAN': 'Panorama M&M GOLD',
  'VVS': 'Panorama VVS',
  'MODO': 'Modo M&M GOLD',
  'KLIF': 'Klif M&M GOLD',
  'GP': 'Galeria Północna M&M GOLD',
  'SB': 'Stary Browar M&M GOLD',
  'MB': 'Marbella',
  'GPAN': 'Główny Panorama',
  'GMODO': 'Główny Modo'
};

export const watchMaterialMap = {
  'steel': 'Stal',
  'steel_yg': 'Stal + Żółte złoto',
  'steel_rg': 'Stal + Różowe złoto',
  'steel_wg': 'Stal + Białe złoto',
  'yg': 'Żółte złoto',
  'wg': 'Białe złoto',
  'rg': 'Różowe złoto',
  'platinum': 'Platyna'
};

export const jewelryMaterialMap = {
  'yg': 'Żółte złoto',
  'wg': 'Białe złoto',
  'rg': 'Różowe złoto',
  'platinum': 'Platyna'
};

export const statusMap = {
  'available': 'Dostępny',
  'sold': 'Sprzedany',
  'reserved': 'Zarezerwowany',
  'service': 'W serwisie',
  'hidden': 'Ukryty'
};

export const categoryMap = {
  'watch': 'Zegarek',
  'ring': 'Pierścionek',
  'engagement_ring': 'Pierścionek zaręczynowy',
  'band': 'Obrączka',
  'necklace': 'Naszyjnik',
  'pendant': 'Zawieszka',
  'bracelet': 'Bransoletka',
  'earrings': 'Kolczyki',
  'brooch': 'Broszka'
};

export const collectionMap = {
  'standard': 'Standard',
  'mm4men': 'MM4MEN',
  'invisible': 'Invisible',
  'mystery': 'Mystery',
  'high_jewelers': 'High Jewelers'
};

export const jewelryTypeMap = {
  'ring': 'Pierścionek',
  'engagement_ring': 'Pierścionek zaręczynowy',
  'band': 'Obrączka',
  'necklace': 'Naszyjnik',
  'pendant': 'Zawieszka',
  'bracelet': 'Bransoletka',
  'earrings': 'Kolczyki',
  'brooch': 'Broszka'
};

export const goldColorMap = {
  'yg': 'Żółte',
  'wg': 'Białe',
  'rg': 'Różowe',
  'three_tone': 'Trójkolorowe'
};

export const stoneTypeMap = {
  'diamond': 'Diament',
  'ruby': 'Rubin',
  'sapphire': 'Szafir',
  'emerald': 'Szmaragd',
  'other': 'Inny'
};

export const stoneShapeMap = {
  'round': 'Okrągły',
  'princess': 'Princess',
  'emerald': 'Emerald',
  'oval': 'Owalny',
  'marquise': 'Markiza',
  'pear': 'Gruszka',
  'cushion': 'Cushion',
  'radiant': 'Radiant',
  'asscher': 'Asscher',
  'heart': 'Serce',
  'other': 'Inny'
};

export const stoneCutMap = {
  'excellent': 'Excellent',
  'very_good': 'Very Good',
  'good': 'Good',
  'fair': 'Fair',
  'poor': 'Poor'
};

export const stoneColorMap = {
  'D': 'D',
  'E': 'E',
  'F': 'F',
  'G': 'G',
  'H': 'H',
  'I': 'I',
  'J': 'J',
  'K': 'K',
  'L': 'L',
  'M': 'M'
};

export const stoneClarityMap = {
  'FL': 'FL',
  'IF': 'IF',
  'VVS1': 'VVS1',
  'VVS2': 'VVS2',
  'VS1': 'VS1',
  'VS2': 'VS2',
  'SI1': 'SI1',
  'SI2': 'SI2',
  'I1': 'I1',
  'I2': 'I2',
  'I3': 'I3'
};

export const claspTypeMap = {
  'standard': 'Standardowe',
  'french': 'Francuskie',
  'omega': 'Omega',
  'safety': 'Z zabezpieczeniem',
  'other': 'Inne'
};

export const braceletMap = {
  'metal': 'Bransoleta metalowa',
  'leather': 'Pasek skórzany',
  'rubber': 'Pasek gumowy',
  'oyster': 'Bransoleta Oyster',
  'jubilee': 'Bransoleta Jubilee',
  'president': 'Bransoleta President',
  'integrated': 'Bransoleta zintegrowana',
  'composite': 'Pasek kompozytowy'
};

export const diamondsMap = {
  'full': 'Pełne wysadzanie',
  'half': 'Częściowe wysadzanie',
  'none': 'Bez diamentów'
};

export const conditionMap = {
  'new': 'Nie noszony',
  'unworn': 'Nie noszony',
  'very_good': 'Bardzo dobry',
  'good': 'Dobry',
  'fair': 'Zadowalający'
};

export const colorMap = {
  'silver': 'Srebrny',
  'gold': 'Złoty',
  'black': 'Czarny',
  'white': 'Biały',
  'blue': 'Niebieski',
  'green': 'Zielony',
  'red': 'Czerwony',
  'brown': 'Brązowy',
  'gray': 'Szary',
  'pink': 'Różowy',
  'purple': 'Fioletowy',
  'orange': 'Pomarańczowy',
  'yellow': 'Żółty',
  'champagne': 'Szampański',
  'mother_of_pearl': 'Masa perłowa',
  'two_tone': 'Dwukolorowy'
};

export const documentsMap = {
  'yes': 'Tak',
  'no': 'Nie'
};

export const goldFinenessMap = {
  '585': '14K (585)',
  '750': '18K (750)',
  '916': '22K (916)',
  '999': '24K (999)'
};

export const settingTypeMap = {
  'prong': 'Na sztyft',
  'bezel': 'Pełna oprawa',
  'channel': 'Kanałowa',
  'pave': 'Pavé',
  'tension': 'Na napięcie',
  'bar': 'Belkowa',
  'invisible': 'Niewidzialna'
};

export const stoneQualityMap = {
  'excellent': 'Doskonała',
  'very_good': 'Bardzo dobra',
  'good': 'Dobra',
  'fair': 'Zadowalająca'
};

export const stonePolishMap = {
  'excellent': 'Excellent',
  'very_good': 'Very Good',
  'good': 'Good',
  'fair': 'Fair',
  'poor': 'Poor'
};

export const stoneSymmetryMap = {
  'excellent': 'Excellent',
  'very_good': 'Very Good',
  'good': 'Good',
  'fair': 'Fair',
  'poor': 'Poor'
};

// Funkcja pomocnicza do tłumaczenia wartości
export const translateValue = (value, mapping) => {
  if (!value) return '';
  return mapping[value] || value;
};
